import { AiFillSetting } from 'react-icons/ai';
import { ImCalendar, ImOffice } from 'react-icons/im';
import { GiArrowScope } from 'react-icons/gi';
import { FormattedMessage } from 'react-intl';
import SettingCard from './components/SettingCard';
import { RiFolderUserLine, RiLockPasswordLine } from 'react-icons/ri';
import SubHeading from '../../../Components/SubHeading';
import { useSelector } from 'react-redux';
import { ErrorMessageHandler, isAdmins } from '../../../_helpers/_methods';
import { GrCertificate } from 'react-icons/gr';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { toast } from 'react-toastify';

function SettingsView() {
  const active_role = useSelector((state) => state.user?.user?.active_role);
  const clearCache = async () => {
    try {
      let response = await fetchWrapper.get('/clean-cache/');
      toast.success(response.message);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  return (
    <div className="card content-section p-3">
      <div className="d-flex justify-content-between align-items-center">
        <SubHeading id="settings" Icon={AiFillSetting} />
        <Button onClick={clearCache}>Clear Cache</Button>
      </div>
      <hr />
      <div className="">
        {isAdmins(active_role) ? (
          <div className="row">
            {[
              {
                path: 'thematic_area',
                title: <FormattedMessage id="thematic_area" />,
                number: <GiArrowScope />,
                color: '#654321',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'fiscal_year',
                title: <FormattedMessage id="fiscal_year" />,
                number: <ImCalendar />,
                color: 'info',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'office_kind',
                title: <FormattedMessage id="office_type" />,
                number: <ImOffice />,
                color: '#458',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'employee_type',
                title: <FormattedMessage id="participant_type" />,
                number: <RiFolderUserLine />,
                color: '#123456',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'employee_type_level',
                title: <FormattedMessage id="employee_type_level" />,
                number: <RiFolderUserLine />,
                color: '#123456',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'sector_type',
                title: <FormattedMessage id="sector_type" />,
                number: <RiFolderUserLine />,
                color: '#123456',
                viewAbleRoles: ['superuser']
              },
              {
                path: 'security/update-password',
                title: <FormattedMessage id="security" />,
                number: <RiLockPasswordLine />,
                color: '#789ABC'
              },
              {
                path: 'certificate_template',
                title: <FormattedMessage id="certificate_template" />,
                number: <StyledCertificateIcon color={'#ABB012'} />,
                color: '#ABB012'
              }
            ]
              .filter((item) => {
                if (item.viewAbleRoles) {
                  return item.viewAbleRoles.includes(active_role);
                } else {
                  return true;
                }
              })
              .map((item, index) => (
                <SettingCard
                  key={index}
                  title={item.title}
                  number={item.number}
                  color={item.color}
                  path={item.path}
                />
              ))}
          </div>
        ) : (
          <div className="row">
            {[
              {
                path: 'security/update-password',
                title: <FormattedMessage id="security" />,
                number: <RiLockPasswordLine />,
                color: '#123456'
              }
            ].map((item, index) => (
              <SettingCard
                key={index}
                title={item.title}
                number={item.number}
                color={item.color}
                path={item.path}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingsView;

const StyledCertificateIcon = styled(GrCertificate)`
  path {
    stroke: ${(props) => props.color};
  }
`;
